<template>
  <ValidationObserver v-slot="{ invalid }">
    <b-overlay :show="busy" rounded="sm">
      <form @submit="sendForm">
        <div v-show="isLoaded">
          <b-row>
            <b-col sm="12" md="6">
              <label>Data dostawy</label>
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-datepicker id="DeliveryDate" v-model="baseForm.deliveryDate" class="mb-2"></b-form-datepicker>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <ProducerPicker ref="producerPicker" />
            <b-col b-col sm="12" md="6">
              <label>Numer rejestracyjny pojazdu</label>
              <v-select label="name" :options="vehicles" v-model="baseForm.vehicle"></v-select>
            </b-col>
            <b-col b-col sm="12" md="6">
              <QuickAdd dispatchName="addVehicle" title="Dodaj samochód dostawcy"
                description="Nie widzisz samochodu na liście? Dodaj go." />
            </b-col>
          </b-row>
          <b-row>
            <b-col b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Rodzaj dokumentu</label>
                <v-select :options="invoiceTypeOptions" :reduce="(x) => x.value"
                  v-model="baseForm.invoiceType"></v-select>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
            <b-col b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <label>Numer faktury lub WZ</label>
                <input type="text" class="form-control" placeholder="Numer faktury lub WZ"
                  v-model="baseForm.invoiceNumber" />
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col b-col sm="12" md="6">
              <label>Data wystawienia faktury</label>
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-datepicker id="invoiceCreationDate" v-model="baseForm.invoiceCreationDate"
                                   class="mb-2"></b-form-datepicker>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
            <b-col sm="12" md="6">
              <validation-provider rules="required" v-slot="{ errors }">
                <b-form-group label="Waluta">
                  <v-select :options="currencyList" :reduce="(x) => x.value"
                            v-model="baseForm.currency"></v-select>
                </b-form-group>
                <div v-if="errors.length > 0" class="alert alert-danger">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </b-col>
          </b-row>

          <div class="accordion" role="tablist">
            <RawMaterialDelivery v-for="item in baseForm.RawMaterials" :rawMaterial="item" :key="item.id"
              :producer="producer" :countries="countries" :products="products"
              @removeItem="RemoveRawMaterialDeliveryFromList" />
          </div>

          <button type="button" class="btn btn-info btn-block not-collapsed" style="overflow-anchor: none"
            @click="addRawMaterial()">
            Dodaj produkt
          </button>

          <b-row>
            <div class="col align-self-end div-form-buttons-area">
              <button type="submit" class="btn-primary btn" :disabled="invalid">
                Zapisz
              </button>
              <button type="button" class="btn-warning btn">
                Wyczyść formularz
              </button>
            </div>
          </b-row>
        </div>
        <div v-show="!isLoaded">
          <Loading ref="loadingSpinner" />
        </div>
      </form>
    </b-overlay>
  </ValidationObserver>
</template>

<script>
import RawMaterialDelivery from '../AddDelivery/RawMaterialDelivery';
import { ValidationObserver } from 'vee-validate';
import toastrMixin from '../../../mixins/toastr';
import currencyMixin from '../../../mixins/currencyMixin';
import ddOptions from '../../../mixins/dropDownOptions';
import QuickAdd from '../../Common/QuickAdd';
import Loading from '../../Common/Loading';
import ProducerPicker from '../Shared/ProducerPicker.vue';
import DeliveryMixins from '../../../mixins/delivery'


export default {
  name: 'EditDelivery',
  components: { RawMaterialDelivery, ValidationObserver, QuickAdd, Loading, ProducerPicker },
  mixins: [toastrMixin, ddOptions, DeliveryMixins,currencyMixin],
  computed: {
    vehicles() {
      return this.$store.state.deliveryFormData.vehicles;
    },
    countries() {
      return this.$store.state.deliveryFormData.countries;
    },
    producer() {
      return this.$store.state.deliveryFormData.producers;
    },
    products() {
      return this.$store.state.deliveryFormData.rawMaterialTypes;
    },
    deliveryQuestions() {
      return this.$store.state.deliveryFormData.deliveryQuestions;
    },
  },
  methods: {
    RemoveRawMaterialDeliveryFromList: function () {
      this.DisplayError('Brak możliwości usuwania', 'Co najmniej jeden produkt musi pozostać w przyjęciu dostawy');
    },
    sendForm: function (evt) {
      evt.preventDefault();
      const that = this;
      const producerPicker = this.$refs.producerPicker;
      if (producerPicker.isCertificateValid) {
        this.busy = true;
        this.baseForm.RawMaterials.forEach(item => item.producer = producerPicker.selectedProducer)
        this.updateRawMaterialDelivery(this.baseForm)
          .then(function (res) {
            if (res.data.success) {
              window.location.href = '/#/PrzyjeteDostawy';
            } else {
              that.DisplayError('Błąd!', res.data.errors[0]);
              that.busy = false;
            }
          })
          .catch(function () {
            that.DisplayError('Wystąpił błąd!', 'Nie udało się zapisać zmian.');
            that.busy = false;
          });
      }
    },

    assignValues: function (delivery) {
      this.baseForm.RawMaterials.push({
        id: this.globalCounter++,
        deliveryQuestions: [],
      });
      var rawMaterial = this.baseForm.RawMaterials[0];
      //Informacje o dostawie
      this.baseForm.vehicle = this.vehicles.filter((x) => x.name == delivery.vehicleIdentifier)[0];
      this.baseForm.invoiceNumber = delivery.invoiceNumber;
      this.baseForm.invoiceType = delivery.invoiceType;
      this.baseForm.invoiceCreationDate = delivery.invoiceCreationDate;
      this.baseForm.deliveryDate = delivery.deliveryDate;
      this.baseForm.id = this.$route.params.id;
      this.baseForm.currency = delivery.currency ? this.currencyList.filter(x=>x.value === delivery.currency)[0] : this.currencyList.filter(x=>x.value === this.pln)[0]

      //Informacje o produkcie
      rawMaterial.Country = this.countries.filter((x) => x.name == delivery.countryName)[0];
      this.$refs.producerPicker.selectedProducer = this.producer.filter((x) => x.id == delivery.producer.id)[0];
      rawMaterial.RawMaterialType = this.products.filter((x) => x.name == delivery.rawMaterialTypeName)[0];
      rawMaterial.SerialNumber = delivery.serialNumber;
      rawMaterial.PackageType = delivery.packageType;
      rawMaterial.DeliveryPackageType = delivery.deliveryPackageType;
      rawMaterial.NumberOfPackages = delivery.numberOfPackages;
      rawMaterial.NumberOfMaterialsInPackage = delivery.numberOfMaterialsInPackage;
      rawMaterial.RawMaterialWeightInPackage = delivery.rawMaterialWeightInPackage;
      rawMaterial.RawMaterialExpireDate = delivery.rawMaterialExpireDate;
      rawMaterial.IsPackedHermetically = delivery.isPackedHermetically;
      rawMaterial.IsDeliveryApproved = delivery.isDeliveryApproved;
      rawMaterial.ApprovedBy = delivery.approvedBy;
      rawMaterial.DeliveryMissMatchComment = delivery.deliveryMissMatchComment;
      rawMaterial.ProductType = delivery.productType
      rawMaterial.pricePerKg = delivery.pricePerKg

      //Odpowiedzi na pytania
      for (var i = 0; i < delivery.deliveryQuestions.length; i++) {
        var deliveryQuestion = delivery.deliveryQuestions[i];
        var tmp = {
          id: deliveryQuestion.id,
          comment: deliveryQuestion.comment,
          deliveryQuestionId: deliveryQuestion.questionId,
          text: deliveryQuestion.text,
          isPassed: deliveryQuestion.isPassed,
        };
        rawMaterial.deliveryQuestions.push(tmp);
      }
    },
  },
  mounted() {
    //Pobranie z Vuex danych do formularza
    this.$store.dispatch('getDeliveryFromData');

    this.getRawMaterialDeliveryById(this.$route.params.id)
      .then((delivery) => {
        this.assignValues(delivery.data);
        this.isLoaded = true;
      })
      .catch((err) => {
        console.log(err);
        this.DisplayError('Wystąpił błąd', 'Nie udało się pobrać danych potrzebnych do formularza');
      });
  },
  data() {
    return {
      busy: false,
      globalCounter: 1,
      isLoaded: false,
      baseForm: {
        deliveryDate: undefined,
        invoiceNumber: '',
        vehicle: '',
        RawMaterials: [],
      },
    };
  },
};
</script>
